import React, { Component } from 'react';
import './NewGameForm.css';

export class OfflineNewGameForm extends Component {
    static displayName = "New game";

  constructor(props) {
      super(props);
      
      this.state = { wordsets: [], loading: true, selectedSet: "", turns: 9 };
  }

  componentDidMount() {
      this.populateWordsData();
    }

    renderNewGameForm() {
        return (<div className="container">
            <div>
            <label>
                Select word set
                <select value={this.state.selectedSet} onChange={x => this.setState({ selectedSet: x.target.value })}>
                    {this.state.wordsets.map(x => <option value={x.name}>{x.name}</option>)}
                </select>
                </label>
            </div>
            <div>
                <label>
                    Select number of turns available (normal game 9, easy game 11)
                <input value={this.state.turns} type="text" pattern="[0-9]{1,2}*" onChange={x => this.setState({ turns: x.target.value })} />
                </label>
            </div>
            <button className={"btn btn-primary"} onClick={() => this.startGame()}>Start game</button>
        </div>);
    }

    startGame() {
        this.props.history.push('offline-game-board/' + this.state.selectedSet + '/' + this.state.turns);
    }

  render() {
    let contents = this.state.loading
      ? <p><em>Loading...</em></p>
      : this.renderNewGameForm();

    return (
      <div>
        {contents}
      </div>
    );
  }

  async populateWordsData() {
      const response = await fetch('wordsets');
    const data = await response.json();
      this.setState({ wordsets: data, loading: false, selectedSet: data[0].name });
  }
}
